import { useEffect, useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Me, type UserSummary } from '../../lib/api';

const linkCls = ({ isActive }: { isActive: boolean }) =>
  `block px-3 py-2 rounded-md text-sm ${
    isActive
      ? 'bg-brand-50 text-brand-700 font-medium'
      : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
  }`;

export function SettingsLayout() {
  const [me, setMe] = useState<UserSummary | null>(null);
  const [meError, setMeError] = useState<string | null>(null);
  const [meLoading, setMeLoading] = useState(true);

  useEffect(() => {
    Me.get()
      .then((r) => setMe(r.user))
      .catch((e: unknown) => setMeError(e instanceof Error ? e.message : 'Failed to load user'))
      .finally(() => setMeLoading(false));
  }, []);

  const isAdmin = me?.role === 'ADMIN';

  return (
    <div className="flex flex-col sm:flex-row gap-6">
      <aside className="w-full sm:w-56 shrink-0">
        <h1 className="text-lg font-semibold text-slate-900 mb-3 px-3">Settings</h1>
        {meError && (
          <p className="px-3 mb-2 text-xs text-red-600">
            Couldn't load your profile: {meError}. Admin items hidden.
          </p>
        )}
        {!meError && meLoading && (
          <p className="px-3 mb-2 text-xs text-slate-500">Loading…</p>
        )}
        <nav className="flex flex-row sm:flex-col gap-1 overflow-x-auto sm:overflow-visible">
          <NavLink to="/settings" end className={linkCls}>
            Device tokens
          </NavLink>
          {isAdmin && (
            <>
              <NavLink to="/settings/users" className={linkCls}>
                Users
              </NavLink>
              <NavLink to="/settings/distribution-lists" className={linkCls}>
                Distribution lists
              </NavLink>
              <NavLink to="/settings/affected-areas" className={linkCls}>
                Affected areas
              </NavLink>
              <NavLink to="/settings/deploy-reviewers" className={linkCls}>
                Deploy reviewers
              </NavLink>
            </>
          )}
        </nav>
      </aside>
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
